













import TextBox from '@/views/atoms/TextBox.vue'
import store from '@/store'
export default

  components: {
    TextBox
  }

  props:
    id:
      type: String
      default: ''
    before_filling:
      type: String
      default: ''
    after_filling:
      type: String
      default: ''
    before_filling_flg:
      type: String
      default: '0'
    after_filling_flg:
      type: String
      default: '0'

  watch: {
    before_filling: (v) ->
      @before = v
      @eBefore_filling = []
      @eAfter_filling = []
    after_filling: (v) ->
      @after = v
      @eBefore_filling = []
      @eAfter_filling = []
  }

  data: () ->
    before: ''
    after: ''
    eBefore_filling: []
    eAfter_filling: []

  computed: {
    abs: () ->
      return Math.round(Math.abs(Number(@before) - Number(@after)) * 10) / 10
  }

  created: () ->
    @before = @before_filling
    @after = @after_filling

  methods: {
    beforeChange: (v) ->
      if v.val
        @eBefore_filling = []
        @eAfter_filling = []
        @before = v.val
        param = @getParam()
        @$emit('change', param, 'before')
    afterChange: (v) ->
      if v.val
        console.log(v.val)
        @eBefore_filling = []
        @eAfter_filling = []
        @after = v.val
        param = @getParam()
        @$emit('change', param, 'after')
    getParam: () ->
      if @before == ''
        before = 0
      else
        before = @before

      if @after == ''
        after = 0
      else
        after = @after
      param =
        id: @id
        before_filling: before
        after_filling: after
        diff: Math.round(Math.abs(Number(@before) - Number(@after)) * 100) / 100
      return param
    error: () ->
      errors = store.getters.errors
      if errors
        if errors['before_filling'] || errors['after_filling']
          if errors['before_filling'] && errors['before_filling'][@id]
            @eBefore_filling[@id] = errors['before_filling'][@id]
          if errors['after_filling'] && errors['after_filling'][@id]
            @eAfter_filling[@id] = errors['after_filling'][@id]
        return
  }
